module.exports = __webpack_public_path__ + "static/MindMate-Naomi-28fec53d759eec36cd2be8c270024a2c.mp4";